import { useNavigate } from 'react-router-dom'
import { SOMYA_ADDICTION_EVENT_URL } from '../../BehavioralAddictionPlan'
import ContentCard from './components/ContentCard/ContentCard'
import { HIWContentCardContainer } from './components/ContentCard/styledComponents'
import Heading from './components/Heading/Heading'
import {
  GetYourPlanButton,
  HowItWordsInnerCardsContainer,
  HowItWorksCardContainer,
} from './styledComponents'

export default function HowItWorks({ buttonsOnClick }) {
  const headingCards = [
    {
      title: 'REACH OUT',
      description:
        'Start your journey with a CHAT WITH AN EXPERT. We’ll schedule a friendly chat to understand your situation and the challenges you’re facing with addiction.',
    },
    {
      title: 'PERSONALIZED PLAN',
      description:
        'Get a recovery plan tailored just for you. After our initial conversation, our experts will create a plan that incorporates proven therapeutic methods and support systems to meet your unique needs.',
    },
    {
      title: 'START PLAN',
      description:
        'Participate in guided sessions and activities. Kickstart your recovery with therapy sessions, workshops, and activities designed to help you understand and overcome your addiction.',
    },
    {
      title: 'CONTINUOUS SUPPORT',
      description:
        'Receive regular check-ins and support. You’ll have ongoing support through frequent check-ins with your dedicated psychologist, who will adjust your plan based on your progress and feedback.',
    },
    {
      title: 'ACHIEVE LIBERATION',
      description:
        'Work towards long-term recovery and thrive. Focus on preventing relapse and gain the tools and strategies needed to stay sober and enjoy your new, addiction-free life.',
    },
  ]
  const navigate = useNavigate()

  return (
    <HowItWorksCardContainer>
      <Heading heading="HOW IT WORKS" />
      <HowItWordsInnerCardsContainer>
        {headingCards?.map((hCrd, idx) => (
          <ContentCard
            key={idx}
            title={hCrd?.title}
            description={hCrd?.description}
            index={idx + 1}
          />
        ))}
        <HIWContentCardContainer style={{ justifyContent: 'center' }}>
          <GetYourPlanButton
            onClick={() => {
              buttonsOnClick
                ? buttonsOnClick()
                : navigate(`${SOMYA_ADDICTION_EVENT_URL}?src=behavioral-addiction-plan`)
            }}
          >
            GET YOUR PLAN
          </GetYourPlanButton>
        </HIWContentCardContainer>
      </HowItWordsInnerCardsContainer>
    </HowItWorksCardContainer>
  )
}
